import React from 'react'
import { Skeleton } from '@material-ui/lab'
import { Box, Card, CardContent } from '@material-ui/core'
import { useStyles } from './HorizontalNewsCardSkeleton.styles'

const HorizontalNewsCardSkeleton = () => {
  const classes = useStyles()

  return (
    <Card className={classes.cardSkeleton}>
      <Skeleton
        variant="rect"
        className={classes.imgSkeleton}
        animation="wave"
      />
      <CardContent className={classes.cardContentSkeleton}>
        <Box className={classes.cardContentItemSkeleton}>
          <Skeleton
            variant="text"
            height={20}
            animation="wave"
            className={classes.category}
          />
          <Skeleton variant="text" width="100%" height={35} animation="wave" />
          <Skeleton variant="text" width="80%" height={35} animation="wave" />
        </Box>
        <Box
          className={`${classes.cardContentItemSkeleton} ${classes.moreRecentTextSkeleton}`}
        >
          {[...Array(4)].map((_, i) => (
            <Skeleton
              key={i}
              variant="text"
              width="100%"
              height={20}
              animation="wave"
            />
          ))}
        </Box>
        <Skeleton
          className={classes.actionsSkeleton}
          variant="text"
          animation="wave"
        />
      </CardContent>
    </Card>
  )
}

export default HorizontalNewsCardSkeleton
